<template>
    <div>
      <trademarkOpposition-responsible-form  :getTrademarkOppositionList="getTrademarkOppositionList" :getTrademarkOppositionResponsibleList="getTrademarkOppositionResponsibleList" ref="trademarkOppositionResponsibleFormModal">
                </trademarkOpposition-responsible-form>
      <b-row>
        <b-col class="col-12">
          <div style="float:right;" class="custom-search d-flex justify-content-end">
            <b-form-group>
              <div class="d-flex align-items-center">
                <b-button style="float:right;" size="sm" variant="outline-primary"
                  @click="getInfo()">{{ $t('trademarkOppositionResponsible.add') }}</b-button>
              </div>
            </b-form-group>
          </div>
        </b-col>
      </b-row>
      <!-- table -->
      <vue-good-table 
      id="trademarkOppositionResponsibleTable"
      ref="trademarkOppositionResponsibleTable" 
      :columns="columns" 
      :rows="rows"
      styleClass="vgt-table condensed tableSize"
      :select-options="{
        enabled: false,
        selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true, // when used in combination with a grouped table, add a checkbox in the header row to check/uncheck the entire group
      }" 
        theme="my-theme">
        <div slot="emptystate">
          {{ $t('dataTable.data_not_found') }}
        </div>
        <!-- Row: Table Row -->
        <template slot="table-column" slot-scope="props">
          <span v-if="props.column.field === 'responsibleName'" class="text-nowrap">
            {{ $t('trademarkOppositionResponsible.name') }}
          </span>
          <span v-else-if="props.column.field === 'email'" class="text-nowrap">
            {{ $t('trademarkOppositionResponsible.email') }}
          </span>
          <span v-else-if="props.column.field === 'mailContactType'" class="text-nowrap">
            {{ $t('trademarkOppositionResponsible.field') }}
          </span>
          <span v-else-if="props.column.field === 'responsibleField'" class="text-nowrap">
            {{ $t('trademarkOppositionResponsible.mail_contact_type') }}
          </span>
          <span v-else-if="props.column.field === 'process'" class="text-nowrap">
            {{ $t('others.process') }}
          </span>
        </template>
        <!-- Column: Table Column -->
        <template slot="table-row" slot-scope="props">
          <!-- Column: Process -->
          <span v-if="props.column.field === 'process'">
            <span>
              <b-button v-b-tooltip.html :title="$t('others.delete')" variant="warning" class="btn-icon mb-1 ml-1"
                size="sm" @click="deleted(props.row)">
                <feather-icon icon="XIcon" />
              </b-button>
            </span>
          </span>
        </template>
      </vue-good-table>
    </div>
  </template>
  
  <script>
  export default {
    props: {
      trademarkOppositionId: Number,
      clientId:Number,
      getTrademarkOppositionList: {type: Function},
    },
    data() {
      return {
        dir: false,
        columns: [
          {
            label: this.$t('trademarkOppositionResponsible.name'),
            field: `responsibleName`,
          },
          {
            label: this.$t('trademarkOppositionResponsible.email'),
            field: `email`,
          },
          {
            label: this.$t('trademarkOppositionResponsible.field'),
            field: `mailContactType`,
          },
          {
            label: this.$t('trademarkOppositionResponsible.mail_contact_type'),
            field: `responsibleField`,
          },
          {
            label: 'Process',
            field: 'process',
            width: '10em'
          },
        ],
        rows: [],
        searchTerm: '',
      }
    },
    mounted() {
      this.getTrademarkOppositionResponsibleList()
    },
    methods: {
      async deleted(data) {
        data = { id: data.id }
        const controller = { name: 'TrademarkOppositionResponsible' }
        const payload = { data: data, controller: controller }
        this.$DeleteConfirm().then(result => {          
          if (result.value) {
            this.$store.dispatch('moduleAuth/delete', payload).then((response) => {
              if (response.data.resultStatus == true) {
                this.$DeleteAlert()
                this.getTrademarkOppositionResponsibleList()
              } else {
                this.$WarningAlert(response.data.resultMessage)
                this.getTrademarkOppositionResponsibleList()
              }
            })
          }
        })
      },
      async getInfo() {
        this.$refs.trademarkOppositionResponsibleFormModal.showInfo(this.trademarkOppositionId, this.clientId)
      },
      getTrademarkOppositionResponsibleList() {
        this.rows = [] 
        const data = { id: this.trademarkOppositionId }
        const controller = { name: 'TrademarkOppositionResponsible', actionName:'GetTrademarkOppositionResponsibleListByTrademarkOppositionId' }
        const payload = { data: data, controller: controller }
        this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
          if (response.data.resultStatus == true) {  
            response.data.trademarkOppositionResponsibleList.forEach(element => {
              this.rows.push(element)
            })
          }
          else {
            this.$WarningAlert(response.data.resultMessage)
          }
        }
        )
      }
    },
  }
  </script>
  <style lang="scss" >
    .tableSize {
      font-size: 13px!important;
      border-collapse: collapse;
      width: 100%;
      max-width: 100%;
      table-layout: auto;
  }
  </style>
  